import ShowCard from '@/components/feature/ShowCard';
import { tvShows } from '@/mocks/tvShows';

export default function CompletedShows() {
  const completedShows = tvShows.filter((s) => s.status === 'completed').slice(0, 8);

  return (
    <section className="w-full bg-background-50">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">
                完结推荐
              </h2>
              <p className="text-sm text-foreground-400 mt-1">一口气看完，根本停不下来</p>
            </div>
            <a
              href={`/category/all`}
              className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              查看全部
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {completedShows.map((show) => (
              <div key={show.id} data-product-shop="">
                <ShowCard show={show} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}